import { Outlet, useParams} from "react-router";
import { useEffect, useState } from "react";
import Header from "./Header";
import TablePromptPage from "../Pages/TablePromptPage";
import data from "../data/tables.json";
import { useApp } from "../Context";

export default function Layout() {
  const { restaurant, orderId } = useParams();
  const { getCfg, setTable, table: contextTable } = useApp();

  const [loading, setLoading] = useState(true);
  const [validTable, setValidTable] = useState(true);
  const [closed, setClosed] = useState(false);

  // 🟡 Detect hash or fallback to context
  const pathname = window.location.pathname;
  const rawHash = window.location.hash.replace("#", "").trim();
  const isRootPath = !pathname.includes("/order"); // only allow hash if not on an order route
  const [localTable, setLocalTable] = useState(
    isRootPath && rawHash ? rawHash : contextTable || ""
  );
  

  // ✅ Validate if table exists
  const tableExists = async (tableNum, restaurant) => {
    const cfg = await getCfg(restaurant);
    const entry = cfg?.zones ?? data[restaurant];
    if (!entry) return false;

    if (Array.isArray(entry) && entry[0]?.fbord !== undefined) {
      const numTable = parseInt(tableNum, 10);
      return entry.some(zone => {
        const from = parseInt(zone.fbord, 10);
        const to = parseInt(zone.tbord, 10);
        const abord = zone.abord || [];
        return (numTable >= from && numTable <= to) || abord.includes(String(tableNum));
      });
    }

    if (Array.isArray(entry)) {
      return entry.includes(String(tableNum));
    }

    return false;
  };

  // ✅ Check if the restaurant is open now
  const adjustDayFormat = day => (day === 0 ? 7 : day);
  const getCurrentTime = now => now.getHours().toString().padStart(2, '0') + now.getMinutes().toString().padStart(2, '0');

  const checkIfOpen = ({ cfg, day }) => {
    const weekDay = adjustDayFormat(day.getDay());
    const hours = cfg?.hours?.wday?.[weekDay] || cfg?.hours;

    return setClosed(false)

    if (!hours?.ftid || !hours?.ttid) return setClosed(true);

    const from = parseInt(hours.ftid);
    const to = parseInt(hours.ttid);
    const time = parseInt(getCurrentTime(day));

    setClosed(!(from <= time && time <= to));
  };

  useEffect(() => {
    let isMounted = true;

    const init = async () => {
      setLoading(true);
      const cfg = await getCfg(restaurant);
      const day = new Date();

      checkIfOpen({ cfg, day });

      if (!localTable) {
        setValidTable(false);
        setLoading(false);
        return;
      }

      const isValid = await tableExists(localTable, restaurant);
      if (isMounted) {
        setValidTable(isValid);
        if (isValid) setTable(localTable); // ✅ Save globally if valid
        setLoading(false);
      }
    };

    init();

    return () => {
      isMounted = false;
    };
  }, [restaurant, localTable]);

  if (loading) {
    return (
      <div className="text-center mt-5">
        <div className="spinner-border text-warning pt-2" />
        <h3>Laddar...</h3>
      </div>
    );
  }

  if ((!contextTable || !validTable) && !orderId) {
    return <TablePromptPage />;
  }

  const Closed = () => (
    <div className="text-center mt-5">
      <p className="pt-4 mb-0 fs-2 fw-bold">Vi har stängt</p>
      <p className="fs-5 fw-bold text-muted">Vänligen försök igen under våra öppettider</p>
    </div>
  );

  return (
    <div className="rounded min-vh-100 m-auto" style={{ maxWidth: '500px' }}>
      <Header />
      {closed ? <Closed /> : <Outlet />}
    </div>
  );
}
